import { Typography, LinearProgress, styled } from "@mui/material";
import { linearProgressClasses } from '@mui/material/LinearProgress';
import { useNavigate } from 'react-router-dom';

const BorderLinearProgress = styled(LinearProgress)(() => ({
  height: 4,
  borderRadius: 2,
  marginTop: 4,
  [`& .${linearProgressClasses.bar}`]: {
    backgroundColor: '#fed407',
  },
}));

function Stepper(props) {
  const { name, redirectTo, isActive, percentage, completed, isSmallScreen, isObjectionScreen } = props;
  const navigate = useNavigate();

  return (
    <div
      style={{
        padding: isSmallScreen ? 12 : '24px 30px',
        borderBottom: isSmallScreen ? 'none' : '1px solid #ffffff75',
        ...((completed && name !== "KYC Verification") ? { cursor: 'pointer' } : {})
      }}
      onClick={(!completed || isObjectionScreen || name === "KYC Verification") ? () => { } : () => navigate(redirectTo)}
    >
      <Typography variant="subtitle" style={{ color: ((!isActive && !completed) || isObjectionScreen || (completed && name === "KYC Verification")) ? '#BAF4FF' : "#fff", fontWeight: 600, paddingBottom: 8, textDecoration: 'none', whiteSpace: 'nowrap' }}>{name}</Typography>
      {(isActive && !isObjectionScreen) && <BorderLinearProgress variant="determinate" value={percentage} />}
    </div>
  )
}

export default Stepper;